import { ReactElement } from "react";
import { Tooltip } from "@mui/material";

// Why a Strategy Report filter is inert: its filters and settings are locked
// while a Calculate run is in flight (task 8279), since a change could not
// reach the run anyway.
export const FILTERS_LOCKED_HINT = "Wait for the calculation to finish";

/**
 * Says FILTERS_LOCKED_HINT on hover over `children` while `locked`. A
 * disabled control fires no mouse events, so the span carries the hover.
 * The span is there locked or not: wrapping only while locked would remount
 * `children` on every lock, dropping an uncontrolled picker's value.
 */
export const LockedTooltip = ({
  locked,
  children,
}: {
  locked: boolean;
  children: ReactElement;
}) => (
  <Tooltip title={locked ? FILTERS_LOCKED_HINT : ""}>
    <span style={{ display: "inline-flex" }}>{children}</span>
  </Tooltip>
);
